<template>
    <div>
        <modal
            class="new-modal-small"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #dfe8f4 !important; height: 30em !important;">
                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/ducks.svg" style="height: 10rem !important" />
                <span class="mt-5">
                    Are you sure you want to delete the <br /> <span class="fw-600">{{address_type  || "Current Address (Shipping Address)"}}</span>?
                </span>
                <div class="d-flex aligin-items-center justify-content-center mt-5">        
                    <button
                        type="button"
                        class="btn btn-new-green btn-smm"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="addressDelete"
                    >YES</button>
                    <button
                        class="btn btn-new-danger btn-smm ml-3"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="cancelDelete"
                    >NO</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","address_type","index", "address_id"],
    methods: {
        addressDelete() {
            this.$emit("addressDelete", {index: this.index, id: this.address_id});
        },
        cancelDelete() {
            this.$emit("cancelDelete");
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/DeleteAddress.vue